/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetUserCards200ResponseInnerReissueOneOf1
 */
export interface GetUserCards200ResponseInnerReissueOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInnerReissueOneOf1
     */
    'cardType': GetUserCards200ResponseInnerReissueOneOf1CardTypeEnum;
    /**
     * Expiration date of the previous physical card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof GetUserCards200ResponseInnerReissueOneOf1
     */
    'expiredDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInnerReissueOneOf1
     */
    'isRenewalProcessing': boolean;
}

export const GetUserCards200ResponseInnerReissueOneOf1CardTypeEnum = {
    physical: 'physical'
} as const;

export type GetUserCards200ResponseInnerReissueOneOf1CardTypeEnum = typeof GetUserCards200ResponseInnerReissueOneOf1CardTypeEnum[keyof typeof GetUserCards200ResponseInnerReissueOneOf1CardTypeEnum];


